import React, { PropsWithChildren } from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useStoreSelector } from "../../helpers/hooks/useStoreSelector"
import { useAuthStore } from "../../store/states/useAuthStore"

interface Props {
  fallback?: unknown
  condition?: boolean
}

const ROUTE_LOGIN = "/login"

const AuthGuard = ({ children, fallback, condition = true }: PropsWithChildren<Props>) => {
  const { token } = useStoreSelector(useAuthStore, "token")
  const { pathname } = useLocation()

  if (!condition) {
    return typeof fallback === "function" ? fallback() : fallback
  }

  console.log("[AUTH GUARD] render — pathname=", pathname,
    " token=", token ? `${token.substring(0, 40)}... (${token.length} chars)` : "VUOTO")
  if (!token) {
    console.warn("[AUTH GUARD] token VUOTO → redirect a", `${ROUTE_LOGIN}?callbackUrl=${pathname}`)
    return <Navigate to={`${ROUTE_LOGIN}?callbackUrl=${pathname}`} />
  }

  return (
    children || <Outlet />
  ) as React.ReactElement
}

export default AuthGuard
